/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    initWizardMultiSearchState,
    WIZARD_MULTI_SEARCH_ATTACH_FILE,
    WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED,
    WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED,
    WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL,
    WIZARD_MULTI_SEARCH_SET_PARAMS,
    WIZARD_MULTI_SEARCH_SET_STEP_VALID,
} from './constant';
import {
    IWizardMultiSearchStepConfirm,
    IWizardMultiSearchStepSelection,
    IWizardMultiSearchValidation,
    TWizardMultiSearchActions,
} from './types';

export interface IWizardMultiSearchReducer extends IWizardMultiSearchStepSelection, IWizardMultiSearchStepConfirm {
    validation: IWizardMultiSearchValidation;
    // attach file
    fileError?: string;
    fileIsLoading: boolean;
    fileName: string;
    // subscriber list
    msisdn: string[];
    msisdnHasMore: boolean;
    msisdnIsLoading: boolean;
    msisdnError: string;
    msisdnNotFound: string[];
    msisdnNotFoundHasMore: boolean;
    msisdnNotFoundIsLoading: boolean;
    msisdnNotFoundError: string;
}

const wizardMultiSearchReducer: Reducer<IWizardMultiSearchReducer, TWizardMultiSearchActions> =
    (state = initWizardMultiSearchState, action: TWizardMultiSearchActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIZARD_MULTI_SEARCH_SET_STEP_VALID:
                    draft.validation.isValid = action.payload.isStepValid;
                    draft.validation.error = action.payload.validateError;
                    break;

                case WIZARD_MULTI_SEARCH_SET_PARAMS:
                    Object.assign(draft, { ...draft, ...action.payload });
                    break;

                /* attach file */
                case WIZARD_MULTI_SEARCH_ATTACH_FILE:
                    draft.fileIsLoading = true;
                    draft.fileName = '';
                    draft.fileError = undefined;
                    break;
                case WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL:
                    draft.fileIsLoading = false;
                    draft.fileName = action.payload.fileName;
                    break;
                case WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED:
                    draft.fileIsLoading = false;
                    draft.fileError = action.payload;
                    break;

                // subscriber list
                case WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST:
                    if (action.payload.isFound) {
                        draft.msisdnIsLoading = true;
                        draft.msisdnError = '';
                    } else {
                        draft.msisdnNotFoundIsLoading = true;
                        draft.msisdnNotFoundError = '';
                    }
                    break;
                case WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL:
                    if (action.payload.isFound) {
                        draft.msisdn = action.payload.msisdn
                        draft.msisdnHasMore = action.payload.hasMore;
                        draft.msisdnIsLoading = false;
                    } else {
                        draft.msisdnNotFound = action.payload.msisdn
                        draft.msisdnNotFoundHasMore = action.payload.hasMore;
                        draft.msisdnNotFoundIsLoading = false;
                    }
                    break;
                case WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED:
                    if (action.payload.isFound) {
                        draft.msisdnIsLoading = false;
                        draft.msisdnError = action.payload.error;
                    } else {
                        draft.msisdnNotFoundIsLoading = false;
                        draft.msisdnNotFoundError = action.payload.error;
                    }
                    break;
            }
        });

export default wizardMultiSearchReducer;
